<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column.is-12
            h3.title.is-3 Firmar Baja&nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-4
            CardBaja(:baja="baja_firmar" :items="items")
          .column.is-8
            ContainerItemBaja(:baja="baja_firmar" :items="items" @itemsAceptados="checkItemsAceptados" @saveObservacion="saveObservacion" @deleteObservacion='deleteObservacion')
        .columns.is-mobile
          .column.is-12-mobile.is-offset-3-tablet.is-6-tablet
            Signature(@saveFile="checkFile" v-show="verFirmas" @sigWebStatus="sigWebStatus")
        .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import Signature from './Signature.vue'
  import CardBaja from './CardBaja.vue'
  import ContainerItemBaja from './ContainerItemBaja.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'

  export default {
    name: 'FirmarSalida',
    components: { Loader, NavBarInventario, InventarioServices, Signature, CardBaja, ContainerItemBaja },
    data() {
      return {
        isLoading: true,
        items: [],
        w: 320,
        h: 220,
        ruta: '',
        firma: '',
        nombreFile: '',
        verFirmas: true
      }
    },
    methods: {
      iniciarComponente() {

        switch (this.baja_firmar.firma) {
          case 'B':
            this.nombreFile = `firma_realiza_${this.baja_firmar.id_baja}`  
            break
          case 'A':
            this.nombreFile = `firma_autoriza_${this.baja_firmar.id_baja}`
            break
          case 'V':
            this.nombreFile = `firma_visto_bueno_${this.baja_firmar.id_baja}`
            break
          default:
            this.nombreFile = `No firma`
            break
        }
        
        this.obtenerItem()
      },
      onLoad (event) {
        console.log(event)
      },
      onDocumentLoad (event) {
        console.log(event)
      },
      checkFile (file) {
        console.log(file)
        this.firma = file
        
        if (this.firma !== 'NoData') {
          InventarioServices.FirmarBaja(this.baja_firmar.id_baja, this.baja_firmar.firma, this.firma, this.nombreFile)
            .then( data => {
              console.log(data)
              const tema = data.success ? 'toasted-primary' : 'bubble'
              const icon = data.success ? 'done' : 'ban'
              this.displayToast(tema, data.respuesta, icon, 'OK')
              if (data.success) {
                this.backInventarios()
              }
            })
            .catch( e => {
              this.displayToast('bubble', `Error ${e.message}`, 'ban', 'OK')
              this.isLoading = false
            })
        } else {
          console.log('No Guardar la Firma')
          this.displayToast('bubble', 'Error: No se ha firmado aún la asignacion.', 'ban', 'OK')
        }
      },
      obtenerItem () {
        this.items = []
        InventarioServices.getArticuloBaja(this.baja_firmar.id_articulo)
          .then( data => {
            this.items.push(this.convetirArticulo(data[0]))
            this.isLoading = false
          })
          .catch( e=> {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },
      convetirArticulo(a) {
        return {
          ...a,
          estado: parseInt(a.estado),
          garantia: parseInt(a.garantia),
          id_artBase: parseInt(a.id_artBase),
        }
      },
      checkItemsAceptados(items) {
        if (items.length > 0) {
          this.verFirmas = true
        } else {
          this.verFirmas = false
        }
      },
      backInventarios() {
        this.$store.commit('firmarBaja', {})
        this.$router.push('/Inventario/Almacen/Bajas')
      },
      backPage() {
        this.$store.commit('firmarBaja', {})
        this.$router.back()
      },
      saveObservacion (data) {
        this.isLoading = true
        console.log('saveObservacionFB')
        InventarioServices.updateObservacionBaja(this.baja_firmar.id_baja, data.observacion)
          .then((resp) => {
            console.log(resp)
            if (resp.success) {
              this.obtenerItem()
              this.displayToast('toasted-primary',`Observación de ${data.descripcion} ha sido registrada.`, 'done', 'Ok')
            } else {
              this.displayToast('bubble',`Error: ${resp.respuesta}`, 'ban', 'Ok')
            }
            this.isLoading = false
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
          })
          
      },
      deleteObservacion(data) {
        this.isLoading = true
        console.log('deleteObservacionFA')
        InventarioServices.updateObservacionBaja(this.baja_firmar.id_baja, '')
          .then((resp) => {
            console.log(resp)
            if (resp.success) {
              this.obtenerItem()
              this.displayToast('toasted-primary',`Observación de ${data.descripcion} ha sido registrada.`, 'done', 'Ok')
            } else {
              this.displayToast('bubble',`Error: ${resp.respuesta}`, 'ban', 'Ok')
            }
            this.isLoading = false
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
          })
      },

      sigWebStatus (val) {
        console.log(val)
        const tema = val ? 'toasted-primary' : 'bubble'
        const text = val ? 'sigWeb instalado' : 'No está instalado sigWeb'
        const icon = val ? 'done' : 'ban'
        this.displayToast(tema, text, icon, 'Ok' )
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'baja_firmar'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/FirmarBaja.vue